// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[class*="softlite-block-"]:hover {
    outline: 1px dashed #ddd;
}

.softlite-block-empty {
    min-height: 30px;
    outline: 1px dashed #ddd;
}

[class*="editor-block-list-item-softlite-io-integration-"] .block-editor-block-types-list__item-icon {
    color: #3845EE !important;
}
.softlite-basic-text-dynamic .softlite-dynamic-dropdown{
    position: absolute;
    top: 30px;
    right: 1px;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/block/basic-text/basic-text.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd","sourcesContent":["[class*=\"softlite-block-\"]:hover {\n    outline: 1px dashed #ddd;\n}\n\n.softlite-block-empty {\n    min-height: 30px;\n    outline: 1px dashed #ddd;\n}\n\n[class*=\"editor-block-list-item-softlite-io-integration-\"] .block-editor-block-types-list__item-icon {\n    color: #3845EE !important;\n}\n.softlite-basic-text-dynamic .softlite-dynamic-dropdown{\n    position: absolute;\n    top: 30px;\n    right: 1px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
